function withOptional(label: any, required = false, asterisk = false) {
  const symbol = required && asterisk ? '*' : '';

  if (!label) {
    return null;
  }

  return `${label} ${symbol}`.trim();
}

export default withOptional;
